import { MissingDocumentEditForm } from 'application/missing-document/forms';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { MissingDocumentService } from 'application/missing-document/services';
import { action } from 'mobx';
import { ItemCategoryService} from 'application/product/services';

@applicationContext
class MissingDocumentEditViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new MissingDocumentService(rootStore.application.baasic.apiClient);
        const itemCategoryService = new ItemCategoryService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'role',
            id: id,
            Form: MissingDocumentEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: MissingDocumentEditForm,
        });

        this.itemCategoryStore = new BaasicDropdownStore({ filterable: true }, {
            fetchFunc: async (term) => {
                const response = await itemCategoryService.find({
                    searchQuery: term,
                    rpp: 100
                });
                return response.data.item;
            }
        });
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Missing Document already exists.' : err.data.message : `Error occurred while trying to update a missing document`
            );
        }
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.notifySuccessCreate(), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Missing Document already exists.' : err.data.message : `Error occurred while trying to create a missing document`
            );
        }
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('MISSING_DOCUMENT.CREATE.SUCCESS');
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('MISSING_DOCUMENT.EDIT.SUCCESS', name);
    }
}

export default MissingDocumentEditViewStore;